<template>
  <header class="the-header">
    <div class="the-header__inner">
      <router-link to="/" class="the-header__logo" aria-label="Prestige Inside — на главную">PRESTIGE INSIDE</router-link>
      <nav class="the-header__nav">
        <router-link to="/" class="the-header__link">Главная</router-link>
        <router-link to="/prices" class="the-header__link">Цены</router-link>
        <router-link to="/catalog" class="the-header__link">Наши работы</router-link>
        <router-link to="/reviews" class="the-header__link">Отзывы</router-link>
        <router-link to="/faq" class="the-header__link">FAQ</router-link>
        <router-link to="/contacts" class="the-header__link">Контакты</router-link>
      </nav>
      <SocialIcons class="the-header__social" />
      <button type="button" class="the-header__cta" @click="goToOrder">
        Заказать
      </button>
      <button type="button" class="the-header__burger" aria-label="Меню" @click="open = !open" :aria-expanded="open">
        <span></span><span></span><span></span>
      </button>
    </div>
    <Transition name="mobile-menu">
      <div v-if="open" class="the-header__mobile-nav" @click.self="closeMenu">
        <div class="the-header__mobile-nav-content">
          <router-link to="/" class="the-header__link" @click="closeMenu">Главная</router-link>
          <router-link to="/prices" class="the-header__link" @click="closeMenu">Цены</router-link>
          <router-link to="/catalog" class="the-header__link" @click="closeMenu">Наши работы</router-link>
          <router-link to="/reviews" class="the-header__link" @click="closeMenu">Отзывы</router-link>
          <router-link to="/faq" class="the-header__link" @click="closeMenu">FAQ</router-link>
          <router-link to="/contacts" class="the-header__link" @click="closeMenu">Контакты</router-link>
        </div>
        <div class="the-header__mobile-nav-cta-wrap">
          <button type="button" class="the-header__mobile-cta" @click="goToOrderAndClose">Заказать</button>
        </div>
        <div class="the-header__mobile-nav-footer">
          <SocialIcons large class="the-header__mobile-social" />
          <button type="button" class="the-header__mobile-close" @click="closeMenu">Закрыть</button>
        </div>
      </div>
    </Transition>
  </header>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import SocialIcons from '@/components/SocialIcons.vue'

export default {
  name: 'TheHeader',
  components: { SocialIcons },
  setup() {
    const open = ref(false)
    const store = useStore()

    function goToOrder() {
      store.commit('setOrderModalOpen', true)
    }

    function closeMenu() {
      open.value = false
    }

    function goToOrderAndClose() {
      open.value = false
      store.commit('setOrderModalOpen', true)
    }

    return { open, goToOrder, closeMenu, goToOrderAndClose }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.the-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: $header-bg;
  color: $header-text;
  height: $header-height;
  box-shadow: 0 2px 12px #232323;

  @media (max-width: $breakpoint-tablet) {
    height: $header-height-mobile;
  }

  &__inner {
    max-width: $container-max;
    margin: 0 auto;
    padding: 0 $gap;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    display: inline-block;
    color: $header-text;
    text-decoration: none;
    font-weight: 800;
    font-size: clamp(16px, 1.6vw, 18px);
    letter-spacing: 0.08em;
    flex-shrink: 0;
    transition: opacity 0.2s;
    transform-style: preserve-3d;
    animation: the-header-logo-spin 10s ease-in-out infinite;

    &:hover {
      opacity: 0.9;
    }
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 32px;

    @media (max-width: $breakpoint-tablet) {
      display: none;
    }
  }

  &__social {
    margin-right: 8px;
    color: $header-text;

    @media (max-width: $breakpoint-tablet) {
      display: none;
    }
  }

  &__cta {
    margin-left: 32px;
    padding: 10px 22px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    background: transparent;
    color: $header-text;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    cursor: pointer;
    transition:
      background 0.25s cubic-bezier(0.22, 1, 0.36, 1),
      color 0.25s cubic-bezier(0.22, 1, 0.36, 1),
      box-shadow 0.25s cubic-bezier(0.22, 1, 0.36, 1),
      transform 0.15s ease-out;

    &:hover {
      background: $color-accent-teal;
      color: $color-primary-inverse;
      box-shadow: 0 10px 30px rgba(13, 148, 136, 0.5);
      transform: translateY(-1px);
    }

    @media (max-width: $breakpoint-tablet) {
      display: none;
    }
  }

  &__link {
    color: $header-text;
    text-decoration: none;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.02em;
    transition: color 0.2s, opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }

    &.router-link-active,
    &.router-link-exact-active {
      color: $color-accent-teal;
    }
  }

  &__burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    width: 40px;
    height: 40px;
    padding: 0;
    background: none;
    border: none;
    color: $header-text;
    cursor: pointer;

    span {
      display: block;
      width: 24px;
      height: 2px;
      background: currentColor;
    }

    @media (max-width: $breakpoint-tablet) {
      display: flex;
    }
  }

  &__mobile-nav {
    display: none;
    position: fixed;
    inset: 0;
    z-index: 200;
    flex-direction: column;
    background: $header-bg;
    padding: 0;
    padding-bottom: env(safe-area-inset-bottom, 0);

    @media (max-width: $breakpoint-tablet) {
      display: flex;
    }
  }

  &__mobile-nav-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: $header-height-mobile 24px 24px;
  }

  &__mobile-nav-content .the-header__link {
    font-size: 16px;
    padding: 12px 20px;
    width: 100%;
    max-width: 280px;
    text-align: center;
    border-radius: 12px;
    transition: background 0.2s, color 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }

    &.router-link-active,
    &.router-link-exact-active {
      color: $color-accent-teal;
      background: rgba(97, 130, 111, 0.2);
    }
  }

  &__mobile-nav-cta-wrap {
    flex-shrink: 0;
    padding: 0 24px 16px;
    display: flex;
    justify-content: center;
  }

  &__mobile-cta {
    width: 100%;
    max-width: 280px;
    padding: 14px 24px;
    font-size: 13px;
    font-weight: 700;
    color: $color-primary-inverse;
    background: $color-accent-teal;
    border: none;
    border-radius: 14px;
    cursor: pointer;
    font-family: inherit;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    box-shadow: 0 8px 24px rgba(97, 130, 111, 0.45);
    transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;

    &:hover {
      opacity: 0.95;
      box-shadow: 0 12px 32px rgba(97, 130, 111, 0.55);
    }

    &:active {
      transform: scale(0.98);
    }
  }

  &__mobile-nav-footer {
    flex-shrink: 0;
    padding: 20px 24px 28px;
    padding-bottom: max(28px, env(safe-area-inset-bottom));
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  &__mobile-social {
    color: $header-text;
  }

  &__mobile-close {
    width: 100%;
    max-width: 280px;
    padding: 12px 24px;
    font-size: 13px;
    font-weight: 600;
    color: $header-bg;
    background: $header-text;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-family: inherit;
    letter-spacing: 0.04em;
    transition: opacity 0.2s, transform 0.15s;

    &:hover {
      opacity: 0.95;
    }

    &:active {
      transform: scale(0.98);
    }
  }
}

.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: opacity 0.25s ease;
}
.mobile-menu-enter-from,
.mobile-menu-leave-to {
  opacity: 0;
}
.mobile-menu-enter-active .the-header__mobile-nav-content,
.mobile-menu-leave-active .the-header__mobile-nav-content {
  transition: transform 0.25s ease;
}
.mobile-menu-enter-from .the-header__mobile-nav-content,
.mobile-menu-leave-to .the-header__mobile-nav-content {
  transform: translateY(-8px);
}

@keyframes the-header-logo-spin {
  0% { transform: rotateY(0deg); }
  80% { transform: rotateY(0deg); }
  100% { transform: rotateY(360deg); }
}
</style>
